import React, {  useState, useEffect, useContext} from 'react';
import { Route, Routes, useNavigate, NavLink} from 'react-router-dom';



import Member from './member/member';

import ClassTable from './class/class';

import Trainer from './trainer/trainer';

import { FcBusinessman, FcManager, FcPortraitMode, FcAutomotive , FcShipped, FcHome, FcDonate } from "react-icons/fc";
import { GiWeightLiftingUp, GiGymBag  } from 'react-icons/gi';
import { FaDumbbell } from 'react-icons/fa'; 
import { DataContext } from '../init/getData';

function AccountTab(props) {

  const navigate = useNavigate();

  const {settingData, userData} = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;


  const [activeTab, setActiveTab] = useState('member');

  
  useEffect(() => {

    navigate('/accountTab/member');
  }, []);


  return (
    <div className="card" style={{paddingTop : '0px', userSelect: 'none'}}>
      
      <div>

       <NavLink to="member"  onClick={() => setActiveTab('member')}>
          <div className={`${activeTab === 'member' ? 'tab-three active-link' : 'tab-three'}`} style={{width: '12%'}}>
          <FcManager size={30}/>
            <span className="tab-text">Member</span>
          </div>
        </NavLink>

        <NavLink to="trainer"  onClick={() => setActiveTab('trainer')}>
          <div className={`${activeTab === 'trainer' ? 'tab-three active-link' : 'tab-three'}`} style={{width: '12%'}}>
          <GiWeightLiftingUp color='rgb(255, 128, 0)'  size={30}/>
            <span className="tab-text">Trainer</span>
          </div>
        </NavLink>

        <NavLink to="class"  onClick={() => setActiveTab('class')}>
          <div className={`${activeTab === 'class' ? 'tab-three active-link' : 'tab-three'}`} style={{width: '12%'}}>
          <FaDumbbell  color='rgb(255, 128, 0)'  size={30}/>
            <span className="tab-text">CLass</span>
          </div>
        </NavLink>

        


      
      </div>

 
      <Routes>
       

        <Route path='member' element= {<Member/>}/>
        <Route path='trainer' element= {<Trainer/>}/>
        <Route path='class' element={<ClassTable />} />
        
      </Routes>

    </div>
  );
}

export default AccountTab;
